import React, { useEffect, useState, useCallback } from "react";
import qs from "qs";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import backImage from "styles/common/img/myplan/icon_close2.png";
import logo from "styles/common/img/common/logo2.jpg";
import classnames from "classnames";
import { HorizontalBar, Bar } from "react-chartjs-2";
import AlertConfirmPopup from "components/common/AlertConfirmPopup";
import Constants from "common/Constants";
import { callPost } from "utils/CommonApi";
import { useMemo } from "react";
import { useRef } from "react";
import _ from "lodash";

const COURSE_TYPE = {
    MATH: "MATH",
    ENGM: "ENGM",
};

const SETTING_MATH_CHART = {
    unitReport: {
        data: {
            type: "bar",
            labels: [],
            datasets: [],
        },
        options: {
            indexAxis: "y",
            barPercentage: 0.4,
            // 평균, 성취도(%)
            legend: {
                display: true,
                position: "top",
                align: "end",
                maxWidth: "100",
                maxHeight: "200",
                labels: {
                    padding: 30,
                    // usePointStyle: true,
                    pointStyle: "rect",
                    pointBorderWidth: 1,
                    boxWidth: 12,
                },
            },
            scales: {
                xAxes: [
                    {
                        ticks: {
                            callback: function (value, index, values) {
                                return value + "%";
                            },
                            stepSize: 10,
                        },
                    },
                ],
                yAxes: [
                    {
                        gridLines: {
                            display: false, // X 축 그리드 눈금선을 숨김
                        },
                    },
                ],
            },
            // layout: {
            //     padding: 50,
            // },
        },
    },
    diffReport: {
        type: "bar",
        data: {
            labels: [],
            datasets: [],
        },
        options: {
            indexAxis: "x",
            barPercentage: 1.0,
            legend: {
                display: true,
                position: "top",
                align: "end",
                maxWidth: "100",
                maxHeight: "50",
                labels: {
                    padding: 30,
                    // usePointStyle: true,
                    pointStyle: "rect",
                    pointBorderWidth: 1,
                    boxWidth: 12,
                },
            },
            scales: {
                xAxes: [
                    {
                        gridLines: {
                            display: false,
                        },
                    },
                ],
                yAxes: [
                    {
                        ticks: {
                            callback: function (value, index, values) {
                                return value + "%";
                            },
                            stepSize: 10,
                        },
                        beginAtZero: true,
                    },
                ],
            },
        },
    },
};

const SETTING_ENGM_CHART = {
    unitReport: {
        type: "bar",
        data: {
            labels: [],
            datasets: [],
        },
        options: {
            indexAxis: "y",
            barPercentage: 0.4,
            // 평균, 성취도(%)
            legend: {
                display: true,
                position: "top",
                align: "end",
                maxWidth: "100",
                maxHeight: "50",
                labels: {
                    padding: 30,
                    // usePointStyle: true,
                    pointStyle: "rect",
                    pointBorderWidth: 1,
                    boxWidth: 12,
                },
            },
            scales: {
                xAxes: [
                    {
                        ticks: {
                            // min: 0, // x축의 최소값을 0으로 설정
                            // max: 100, // x축의 최대값을 100으로 설정
                            callback: function (value, index, values) {
                                return value + "%";
                            },
                            stepSize: 10, // x축 눈금 간격을 10으로 설정하여 10%씩 증가하도록 함
                        },
                    },
                ],
                yAxes: [
                    {
                        gridLines: {
                            display: false, // y축의 수평선을 숨김 처리하여 세로 구분선만 나오도록 함
                        },
                    },
                ],
            },
        },
    },
    diffReport: {
        type: "bar",
        data: {
            labels: [],
            datasets: [],
        },
        options: {
            indexAxis: "y",
            barPercentage: 1.0,
            legend: {
                display: true,
                position: "top",
                align: "end",
                maxWidth: "100",
                maxHeight: "50",
                labels: {
                    padding: 30,
                    // usePointStyle: true,
                    pointStyle: "rect",
                    pointBorderWidth: 1,
                    boxWidth: 12,
                },
            },
            scales: {
                xAxes: [
                    {
                        ticks: {
                            // min: 0, // x축의 최소값을 0으로 설정
                            // max: 100, // x축의 최대값을 100으로 설정
                            callback: function (value, index, values) {
                                return value + "%";
                            },
                            stepSize: 10, // x축 눈금 간격을 10으로 설정하여 10%씩 증가하도록 함
                        },
                    },
                ],
                yAxes: [
                    {
                        gridLines: {
                            display: false, // y축의 수평선을 숨김 처리하여 세로 구분선만 나오도록 함
                        },
                    },
                ],
            },
        },
    },
};

export default function AllBackReportCard() {
    const location = useLocation();
    const history = useHistory();

    const query = qs.parse(location.search, {
        ignoreQueryPrefix: true,
    });

    let userId = useSelector((state) => state.loginReducer.userId);
    let mmbrSeq = useSelector((state) => state.loginReducer.mmbrSeq);
    const gradCd = useSelector((state) => state.loginReducer.gradCd);

    const queryObject = qs.parse(location.search, {
        ignoreQueryPrefix: true,
    });

    if (!userId) userId = queryObject.USER_ID;
    if (!mmbrSeq) mmbrSeq = queryObject.MMBR_SEQ;

    const checkedFetching = useRef(false);

    const [courseType, setCourseType] = useState(query?.COURSE_CODE === "ALL" ? "MATH" : query?.COURSE_CODE);

    const [tabInfo, setTabInfo] = useState(null);
    const [respResult, setRespResult] = useState({
        diffReportList: null,
        reportMap: {},
        unitReportList: null,
    });

    const { diffReportList, unitReportList, reportMap } = respResult;
    const {
        GRAD_NM = "", // -- 학년명
        MMBR_NAME = "", // -- 회원 명
        CONTRACT_NUMBER = "", //-- 회원번호
        TOT_CNT = 0, // -- 총시험지 수
        QST_CNT = 0, // -- 총문항 수
        TSPAR_CNT = 0, // -- 응시한 시험지 수
        USE_QST_CNT = 0, // -- 응시한 문항수
        ANSWER_CNT = 0, // -- 정답 수
        WRANSWER_CNT = 0, // -- 오답수
        TCHR_OPIN = "", // -- 선생님 의견
    } = reportMap;

    const [selected, setSelected] = useState({
        year: 0,
        month: 0,
        grade: 0,
    });
    const [selectList, setSelectList] = useState({
        years: [],
        months: [],
        grades: [],
    });

    const [mathChart, setMathChart] = useState(SETTING_MATH_CHART);
    const [engChart, setEngChart] = useState(SETTING_ENGM_CHART);

    const handleClose = () => history.goBack();

    const handleClickTypeBtn = useCallback(
        (event, paramType) => {
            event.preventDefault();
            if (paramType === courseType) return;

            setRespResult((prevState) => ({
                diffReportList: null,
                unitReportList: null,
                reportMap: !_.isEmpty(prevState.reportMap) ? prevState.reportMap : {},
            }));

            setCourseType(paramType);
        },
        [courseType],
    );

    const handleChangeSelectbox = (e) => {
        e.preventDefault();
        if (!e.target.name && !e.target.value) return;

        setSelected({
            ...selected,
            [e.target.name]: e.target.value,
        });
    };

    // tab 또는 월,일,학년 선택 시 호출
    useEffect(() => {
        const fetchData = () => {
            if (!selected.year || !selected.grade || !selected.month) return;

            // console.log("fetchData :: ");

            if (!mmbrSeq) {
                AlertConfirmPopup({
                    type: "ALERT",
                    msg: "데이터를 조회 할 수 없습니다.",
                });
                return;
            }

            // respResult 초기화
            setRespResult((prevState) => ({
                diffReportList: null,
                unitReportList: null,
                reportMap: !_.isEmpty(prevState.reportMap) ? prevState.reportMap : {},
            }));

            try {
                const headerParam = {
                    user_id: userId,
                };

                const queryParam = {
                    MMBR_SEQ: mmbrSeq,
                    COURSE_CODE: courseType || "",
                    GRAD_CD: courseType === "MATH" ? selected?.grade || "" : "ALL",
                    YEAR: selected?.year || "",
                    MONTH: selected?.month || "",
                };

                const param = {
                    REQUEST_API: Constants.PLAYER_API.GET_RSBP_TEST_REPORT_INFO,
                    HTTP_METHOD: Constants.HTTP_METHOD.GET,
                };

                callPost(headerParam, param, callbackFetchData, queryParam); // 탭 조회
            } catch (error) {
                console.error(error);
                AlertConfirmPopup({
                    type: "ALERT",
                    msg: "데이터를 불러오는데 실패했습니다!",
                });
            }
        };

        fetchData();
    }, [selected]);

    const callbackFetchData = (resData) => {
        const { diffReportList = [], reportMap = {}, unitReportList = [] } = resData?.RESP_RESULT;
        const respTabInfo = resData?.RESP_RESULT?.tabInfo.reverse() || [];

        if (!tabInfo || tabInfo.length !== respTabInfo.length) {
            // 초기 탭이 저장하지 않았거나, API의 TAB 데이터가 다른 경우 셋팅
            setTabInfo(respTabInfo);
        }

        setRespResult({
            diffReportList,
            unitReportList,
            reportMap,
        });

        if (courseType === COURSE_TYPE.MATH) {
            // math chart 저장
            const { unitReport, diffReport } = mathChart;
            // const getDiffReportList = getDiffReportListNotMemo(diffReportList); // diffReportList를 상,중,하 로 그룹핑하여 필터한 배열 가져오기 > 변경됨 (2024.04.12)

            const avgPerData = unitReportList.map(({ AVG_PER }) => Number(AVG_PER)); // 평균 리스트
            const stdPerData = unitReportList.map(({ STD_PER }) => Number(STD_PER)); // 성취도 리스트

            // const min = Math.round(Math.min(...[...avgPerData, ...stdPerData]) / 10) * 10;
            // const max = Math.round(Math.max(...[...avgPerData, ...stdPerData]) / 10) * 10;

            setMathChart({
                ...mathChart,
                unitReport: {
                    ...unitReport,
                    data: {
                        labels: unitReportList.map(({ UNIT_NAME }) => UNIT_NAME),
                        datasets: [
                            {
                                label: "성취도(%)",
                                data: stdPerData,
                                backgroundColor: "rgba(255, 99, 132, 0.5)",
                                barPercentage: 1.0, // 간격 없이 막대 표시
                                barThickness: 12, // 막대 두께 설정
                            },
                            {
                                label: "평균(%)",
                                data: avgPerData,
                                backgroundColor: "rgba(54, 162, 235, 0.5)",
                                barPercentage: 1.0, // 간격 없이 막대 표시
                                barThickness: 12, // 막대 두께 설정
                            },
                        ],
                    },
                    option: {
                        ...unitReport.options,
                        scales: {
                            ...unitReport.options.scales,
                            xAxes: [
                                {
                                    ...unitReport.options.scales.xAxes[0],
                                    ticks: {
                                        ...unitReport.options.scales.xAxes[0].ticks,
                                        // min: min > 10 ? min : 10,
                                        // max,
                                    },
                                },
                            ],
                        },
                    },
                },
                diffReport: {
                    ...diffReport,
                    data: {
                        labels: diffReportList.map(({ QST_CNTT_SCTN }) => QST_CNTT_SCTN),
                        datasets: [
                            {
                                label: "상",
                                data: diffReportList.map(({ LV_3 }) => LV_3),
                                backgroundColor: "rgba(255, 99, 132, 0.5)",
                                barPercentage: 1, // 막대 간격을 조정하여 수정
                                barThickness: 20, // 막대 두께 설정
                            },
                            {
                                label: "중",
                                data: diffReportList.map(({ LV_2 }) => LV_2),
                                backgroundColor: "rgba(54, 162, 235, 0.5)",
                                barPercentage: 1, // 막대 간격을 조정하여 수정
                                barThickness: 20, // 막대 두께 설정
                            },
                            {
                                label: "하",
                                data: diffReportList.map(({ LV_1 }) => LV_1),
                                backgroundColor: "rgba(255, 206, 86, 0.5)",
                                barPercentage: 1, // 막대 간격을 조정하여 수정
                                barThickness: 20, // 막대 두께 설정
                            },
                        ],
                    },
                },
            });
        } else {
            // engm chart 저장
            const { unitReport, diffReport } = engChart;

            const avgPerData = unitReportList.map(({ AVG_PER }) => Number(AVG_PER)); // 평균 리스트
            const stdPerData = unitReportList.map(({ STD_PER }) => Number(STD_PER)); // 성취도 리스트

            setEngChart({
                ...engChart,
                unitReport: {
                    ...unitReport,
                    data: {
                        labels: unitReportList.map(({ M_UNIT_NAME }) => M_UNIT_NAME),
                        datasets: [
                            {
                                label: "성취도(%)",
                                data: stdPerData,

                                backgroundColor: "rgba(255, 99, 132, 0.5)",
                                barPercentage: 1.0, // 간격 없이 막대 표시
                                barThickness: 12, // 막대 두께 설정
                            },
                            {
                                label: "평균(%)",
                                data: avgPerData,
                                backgroundColor: "rgba(54, 162, 235, 0.5)",
                                barPercentage: 1.0, // 간격 없이 막대 표시
                                barThickness: 12, // 막대 두께 설정
                            },
                        ],
                    },
                },
                diffReport: {
                    ...diffReport,
                    data: {
                        labels: diffReportList.map(({ UNIT_NAME }) => UNIT_NAME),
                        datasets: [
                            {
                                label: "Lev. 3",
                                data: diffReportList.map(({ LV_3 }) => LV_3),
                                backgroundColor: "rgba(255, 99, 132, 0.5)",
                                barPercentage: 0.3, // 막대 간격을 조정하여 수정
                                barThickness: 12, // 막대 두께 설정
                            },
                            {
                                label: "Lev. 2",
                                data: diffReportList.map(({ LV_2 }) => LV_2),
                                backgroundColor: "rgba(54, 162, 235, 0.5)",
                                barPercentage: 0.3, // 막대 간격을 조정하여 수정
                                barThickness: 12, // 막대 두께 설정
                            },
                            {
                                label: "Lev. 1",
                                data: diffReportList.map(({ LV_1 }) => LV_1),
                                backgroundColor: "rgba(255, 206, 86, 0.5)",
                                barPercentage: 0.3, // 막대 간격을 조정하여 수정
                                barThickness: 12, // 막대 두께 설정
                            },
                        ],
                    },
                },
            });
        }

        checkedFetching.current = false;
    };

    // 그룹맵핑 필요없도록 데이터 구조 변경됨 (2024.04.12)
    // const getDiffReportListNotMemo = (listParams) => {
    //     let tempArrays = [[], [], []];
    //     if (!listParams) return tempArrays;

    //     tempArrays = listParams.reduce(
    //         (acc, item) => {
    //             Object.keys(item).forEach((key) => {
    //                 if (key.startsWith("LV_")) {
    //                     const lvNumber = parseInt(key.split("_")[1]);
    //                     acc[lvNumber - 1].push(item[key]);

    //                     // console.log("lvNumber value : ", lvNumber + " " + item[key]);
    //                 }
    //             });
    //             return acc;
    //         },
    //         [[], [], []],
    //     );

    //     return tempArrays.reverse(); // 상, 중, 하 순서로 나열하기 위해 반전
    // };

    // 그룹맵핑 필요없도록 데이터 구조 변경됨 (2024.04.12)
    // const getDiffReportList = useMemo(() => {
    //     let tempArrays = [[], [], []];

    //     if (!diffReportList) return tempArrays;

    //     tempArrays = diffReportList.reduce(
    //         (acc, item) => {
    //             Object.keys(item).forEach((key) => {
    //                 if (key.startsWith("LV_")) {
    //                     const lvNumber = parseInt(key.split("_")[1]);
    //                     acc[lvNumber - 1].push(item[key]);

    //                     // console.log("lvNumber value : ", lvNumber + " " + item[key]);
    //                 }
    //             });
    //             return acc;
    //         },
    //         [[], [], []],
    //     );

    //     return tempArrays.reverse(); // 상, 중, 하 순서로 나열하기 위해 반전
    // }, [diffReportList]);

    // const handleClickPrintBtn = useCallback(() => {
    //     window.print();
    // }, []);

    useEffect(() => {
        // 연도 옵션을 추가하는 함수
        function populateYearSelect() {
            const currentYear = new Date().getFullYear(); // 현재 연도를 가져옵니다.
            let yearList = [];
            // 연도 옵션을 추가합니다. (현재 연도부터 10년 전까지)
            for (let i = currentYear; i >= currentYear - 10; i--) yearList = [...yearList, { value: i, text: i }];
            return yearList;
        }

        // 월 옵션을 추가하는 함수
        function populateMonthSelect() {
            let monthList = [];
            // 1월부터 12월까지의 월 옵션을 추가합니다.
            for (let i = 1; i <= 12; i++) monthList = [...monthList, { value: i < 10 ? `0${i}` : i, text: i + "월" }];
            return monthList;
        }

        // 학년 옵션을 추가하는 함수
        function populateGradeSelect() {
            let gradeList = [
                {
                    text: "중1",
                    value: "GR21",
                },
                {
                    text: "중2",
                    value: "GR22",
                },
                {
                    text: "중3",
                    value: "GR23",
                },
            ];
            return gradeList;
        }

        const TIME_OUT_ID = setTimeout(() => {
            const years = populateYearSelect();
            const months = populateMonthSelect();
            const grades = populateGradeSelect();

            setSelectList({
                ...selectList,
                years,
                months,
                grades,
            });

            const date = new Date();
            const getYear = date.getFullYear(); // 년
            const getMonth = date.getMonth() + 1; // 월

            setSelected({
                ...selected,
                year: getYear,
                month: getMonth < 10 ? `0${getMonth}` : getMonth,
                grade: gradCd || grades[0].value,
            });
        }, 0);

        return () => clearTimeout(TIME_OUT_ID);
    }, [courseType]);

    useEffect(() => {
        const htmlElement = document.querySelector("html");
        const htmlPrevFontSize = htmlElement.style.fontSize;

        htmlElement.style.fontSize = "62.5%"; // 퍼블된 작업이 62.5% 로 설정 후 작업되어있음

        return () => {
            htmlElement.style.fontSize = htmlPrevFontSize;
            checkedFetching.current = false;
        };
    }, []);

    return (
        <div className="reportcardWrap reportInfor examReportCard">
            <div className="tzbodyWrap">
                <div className="headTz clear">
                    <div className="fl baekbt" onClick={handleClose}>
                        <img src={backImage} alt="뒤로가기" />
                    </div>
                    <div className="fl setTitle"></div>
                </div>
            </div>
            <div className="report">
                <div className="wrap">
                    <div className="wrapper">
                        <div className="header">
                            <div className="left">
                                <div className="logo">
                                    <img src={logo} alt="스마트올중학 스마트올백" />
                                </div>
                            </div>
                        </div>
                        <div className="tabs">
                            <ul className="tab-menu">
                                {tabInfo &&
                                    tabInfo.length > 0 &&
                                    tabInfo.map(({ TAB_NM }, index) => (
                                        <li key={index} className={classnames({ active: courseType === TAB_NM })}>
                                            <a href="#none" onClick={(e) => handleClickTypeBtn(e, TAB_NM)}>
                                                {TAB_NM === COURSE_TYPE.MATH ? "수학" : "영어"}
                                            </a>
                                        </li>
                                    ))}
                            </ul>
                            <div className={classnames("tab-content active")}>
                                {courseType === COURSE_TYPE.MATH ? (
                                    <>
                                        <div className="page">
                                            <div className="page-header">
                                                <div className="left">
                                                    <div className="logo">
                                                        <img src={logo} alt="스마트올중학 스마트올백" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="page-body">
                                                <div className="title-box">
                                                    {selected?.year && selected.month && (
                                                        <h2>{`${selected.year}년 ${selected.month}월 중등 수학 성취도 리포트`}</h2>
                                                    )}
                                                </div>
                                                <div className="user-info-box">
                                                    <div className="left">
                                                        {_.isEmpty(reportMap)
                                                            ? "■"
                                                            : `■ [${GRAD_NM}] ${MMBR_NAME} (${CONTRACT_NUMBER})`}
                                                    </div>
                                                    <div className="right">
                                                        {/* 년도 별*/}
                                                        <div className="form-select">
                                                            <select
                                                                value={selected.year}
                                                                name="year"
                                                                onChange={handleChangeSelectbox}
                                                            >
                                                                {selectList.years?.map(({ value, text }, index) => {
                                                                    if (!value) return null;
                                                                    return (
                                                                        <option key={index} value={value}>
                                                                            {text}
                                                                        </option>
                                                                    );
                                                                })}
                                                            </select>
                                                        </div>
                                                        {/* 월 별 */}
                                                        <div className="form-select">
                                                            <select
                                                                value={selected.month}
                                                                name="month"
                                                                onChange={handleChangeSelectbox}
                                                            >
                                                                {selectList.months?.map(({ value, text }, index) => {
                                                                    if (!value) return null;
                                                                    return (
                                                                        <option key={index} value={value}>
                                                                            {text}
                                                                        </option>
                                                                    );
                                                                })}
                                                            </select>
                                                        </div>
                                                        {/* 학년 별 */}
                                                        <div className="form-select">
                                                            <select
                                                                value={selected.grade}
                                                                name="grade"
                                                                onChange={handleChangeSelectbox}
                                                            >
                                                                {selectList.grades?.map(({ value, text }, index) => {
                                                                    if (!value) return null;
                                                                    return (
                                                                        <option key={index} value={value}>
                                                                            {text}
                                                                        </option>
                                                                    );
                                                                })}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="section">
                                                    <div className="table">
                                                        <table>
                                                            <thead>
                                                                <tr>
                                                                    <th>총 시험지 수 / 총 문항</th>
                                                                    <th>응시한 시험지 수 / 문항 수</th>
                                                                    <th>정답 / 오답</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        {TOT_CNT >= 0 ? `${TOT_CNT}개` : ""}
                                                                        {QST_CNT >= 0 ? ` / ${QST_CNT}문항` : ""}
                                                                    </td>
                                                                    <td>
                                                                        {TSPAR_CNT >= 0 ? `${TSPAR_CNT}개` : ""}
                                                                        {USE_QST_CNT >= 0
                                                                            ? ` / ${USE_QST_CNT}문항`
                                                                            : ""}
                                                                    </td>
                                                                    <td>
                                                                        {ANSWER_CNT >= 0 ? `${ANSWER_CNT}개` : ""}
                                                                        {WRANSWER_CNT >= 0
                                                                            ? ` / ${WRANSWER_CNT}개`
                                                                            : ""}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div className="section">
                                                    <h3>단원별 성취도</h3>
                                                    <div className="chart-area chart-legend" id="chartContainer">
                                                        {unitReportList && unitReportList.length ? (
                                                            <HorizontalBar
                                                                height={
                                                                    unitReportList.length * 20 >= 100
                                                                        ? unitReportList.length * 20
                                                                        : 200
                                                                }
                                                                data={mathChart.unitReport.data}
                                                                options={mathChart.unitReport.options}
                                                            />
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </div>
                                                    <div className="table type2">
                                                        <table id="data-table">
                                                            <colgroup>
                                                                <col width="auto" />
                                                                <col width="15%" />
                                                                <col width="15%" />
                                                                <col width="15%" />
                                                                <col width="15%" />
                                                            </colgroup>
                                                            <thead>
                                                                <tr>
                                                                    <th>단원명</th>
                                                                    <th>문항 수</th>
                                                                    <th>맞힌 문항 수</th>
                                                                    <th>성취도(%)</th>
                                                                    <th>평균(%)</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {!_.isEmpty(unitReportList) ? (
                                                                    unitReportList.map(
                                                                        (
                                                                            {
                                                                                UNIT_NAME,
                                                                                QST_CNT,
                                                                                ANSWER_CNT,
                                                                                STD_PER,
                                                                                AVG_PER,
                                                                            },
                                                                            index,
                                                                        ) => {
                                                                            return (
                                                                                <tr key={index}>
                                                                                    <td>{UNIT_NAME}</td>
                                                                                    <td>{QST_CNT}</td>
                                                                                    <td>{ANSWER_CNT}</td>
                                                                                    <td>{`${STD_PER}%`}</td>
                                                                                    <td>{`${AVG_PER}%`}</td>
                                                                                </tr>
                                                                            );
                                                                        },
                                                                    )
                                                                ) : (
                                                                    <tr>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div className="section">
                                                    <h3>난이도에 따른 평가영역 성취도(%)</h3>
                                                    <div className="chart-area" id="chartContainer2">
                                                        {diffReportList && diffReportList.length > 0 ? (
                                                            <Bar
                                                                height={
                                                                    diffReportList.length * 20 >= 100
                                                                        ? diffReportList.length * 20
                                                                        : 200
                                                                }
                                                                data={mathChart.diffReport.data}
                                                                options={mathChart.diffReport.options}
                                                            />
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </div>

                                                    <div className="table">
                                                        <table>
                                                            <colgroup>
                                                                <col width="auto" />
                                                                <col width="25%" />
                                                                <col width="25%" />
                                                                <col width="25%" />
                                                            </colgroup>
                                                            <thead>
                                                                <tr>
                                                                    <th>구분</th>
                                                                    <th>상</th>
                                                                    <th>중</th>
                                                                    <th>하</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {!_.isEmpty(diffReportList) ? (
                                                                    diffReportList.map(
                                                                        (
                                                                            { QST_CNTT_SCTN, LV_1, LV_2, LV_3 },
                                                                            index,
                                                                        ) => {
                                                                            return (
                                                                                <tr key={`eng_diff_tr_${index}`}>
                                                                                    <td>{QST_CNTT_SCTN}</td>
                                                                                    <td>{LV_3}</td>
                                                                                    <td>{LV_2}</td>
                                                                                    <td>{LV_1}</td>
                                                                                </tr>
                                                                            );
                                                                        },
                                                                    )
                                                                ) : (
                                                                    <tr>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div className="guide-box">
                                                    <p>
                                                        해당 월에 난이도/평가영역별 기준이며, 전체 문항에서 맞힌 문제만
                                                        표에 노출하고 그래프는 맞힌 문제에 대한 %을 제공
                                                    </p>
                                                </div>
                                                {TCHR_OPIN ? (
                                                    <div className="section">
                                                        <div className="comment-box">
                                                            <h3>선생님 의견</h3>
                                                            <textarea
                                                                cols="30"
                                                                rows="10"
                                                                style={{ padding: 12, lineHeight: 1.5 }}
                                                                value={TCHR_OPIN}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <></>
                                                )}
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="page">
                                            <div className="page-header">
                                                <div className="left">
                                                    <div className="logo">
                                                        <img src={logo} alt="스마트올중학 스마트올백" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="page-body">
                                                <div className="title-box">
                                                    {selected?.year && selected.month && (
                                                        <h2>{`${selected.year}년 ${selected.month}월 중등 영어 성취도 리포트`}</h2>
                                                    )}
                                                </div>
                                                <div className="user-info-box">
                                                    <div className="left">
                                                        {_.isEmpty(reportMap)
                                                            ? "■"
                                                            : `■ [${GRAD_NM}] ${MMBR_NAME} (${CONTRACT_NUMBER})`}
                                                    </div>
                                                    <div className="right">
                                                        {/* 년도 별*/}
                                                        <div className="form-select">
                                                            <select
                                                                value={selected.year}
                                                                name="year"
                                                                onChange={handleChangeSelectbox}
                                                            >
                                                                {selectList.years?.map(({ value, text }, index) => {
                                                                    if (!value) return null;
                                                                    return (
                                                                        <option key={index} value={value}>
                                                                            {text}
                                                                        </option>
                                                                    );
                                                                })}
                                                            </select>
                                                        </div>
                                                        {/* 월 별 */}
                                                        <div className="form-select">
                                                            <select
                                                                name="month"
                                                                value={selected.month}
                                                                onChange={handleChangeSelectbox}
                                                            >
                                                                {selectList.months?.map(({ value, text }, index) => {
                                                                    if (!value) return null;
                                                                    return (
                                                                        <option key={index} value={value}>
                                                                            {text}
                                                                        </option>
                                                                    );
                                                                })}
                                                            </select>
                                                        </div>
                                                        {/* 학년 별 */}
                                                        {/* <div className="form-select">
                                                            <select
                                                                value={selected.grade}
                                                                name="grade"
                                                                onChange={handleChangeSelectbox}
                                                            >
                                                                {selectList.grades?.map(({ value, text }, index) => {
                                                                    if (!value) return null;
                                                                    return (
                                                                        <option key={index} value={value}>
                                                                            {text}
                                                                        </option>
                                                                    );
                                                                })}
                                                            </select>
                                                        </div> */}
                                                    </div>
                                                </div>
                                                <div className="section">
                                                    <div className="table">
                                                        <table>
                                                            <thead>
                                                                <tr>
                                                                    <th>총 시험지 수 / 총 문항</th>
                                                                    <th>응시한 시험지 수 / 문항 수</th>
                                                                    <th>정답 / 오답</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        {TOT_CNT >= 0 ? `${TOT_CNT}개` : ""}
                                                                        {QST_CNT >= 0 ? ` / ${QST_CNT}문항` : ""}
                                                                    </td>
                                                                    <td>
                                                                        {TSPAR_CNT >= 0 ? `${TSPAR_CNT}개` : ""}
                                                                        {USE_QST_CNT >= 0
                                                                            ? ` / ${USE_QST_CNT}문항`
                                                                            : ""}
                                                                    </td>
                                                                    <td>
                                                                        {ANSWER_CNT >= 0 ? `${ANSWER_CNT}개` : ""}
                                                                        {WRANSWER_CNT >= 0
                                                                            ? ` / ${WRANSWER_CNT}개`
                                                                            : ""}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div className="section">
                                                    <h3>단원별 성취도</h3>
                                                    <div className="chart-area chart-legend" id="chartContainer">
                                                        {!_.isEmpty(unitReportList) ? (
                                                            <HorizontalBar
                                                                height={
                                                                    unitReportList.length * 20 >= 100
                                                                        ? unitReportList.length * 20
                                                                        : 200
                                                                }
                                                                data={engChart.unitReport.data}
                                                                options={engChart.unitReport.options}
                                                            />
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </div>
                                                    <div className="table type3">
                                                        <table id="data-table2">
                                                            <colgroup>
                                                                <col width="20%" />
                                                                <col width="auto" />
                                                                <col width="12%" />
                                                                <col width="14%" />
                                                                <col width="12.2%" />
                                                                <col width="12%" />
                                                            </colgroup>
                                                            <thead>
                                                                <tr>
                                                                    <th>대단원</th>
                                                                    <th>중단원</th>
                                                                    <th>문항 수</th>
                                                                    <th>맞힌 문항 수</th>
                                                                    <th>성취도(%)</th>
                                                                    <th>평균(%)</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {!_.isEmpty(unitReportList) ? (
                                                                    unitReportList.map(
                                                                        (
                                                                            {
                                                                                L_UNIT_NAME,
                                                                                M_UNIT_NAME,
                                                                                QST_CNT,
                                                                                ANSWER_CNT,
                                                                                STD_PER,
                                                                                AVG_PER,
                                                                            },
                                                                            index,
                                                                        ) => {
                                                                            // const ACH_PER = Math.ceil(
                                                                            //     (ANSWER_CNT / QST_CNT) * 100,
                                                                            // );
                                                                            return (
                                                                                <tr key={`eng_unit_tr_${index}`}>
                                                                                    <td>{L_UNIT_NAME}</td>
                                                                                    <td>{M_UNIT_NAME}</td>
                                                                                    <td>{QST_CNT}</td>
                                                                                    <td>{ANSWER_CNT}</td>
                                                                                    <td>{`${STD_PER}%`}</td>
                                                                                    <td>{`${AVG_PER}%`}</td>
                                                                                </tr>
                                                                            );
                                                                        },
                                                                    )
                                                                ) : (
                                                                    <tr>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div className="section">
                                                    <h3>대단원/레벨별 성취도(%)</h3>
                                                    <div className="chart-area">
                                                        {!_.isEmpty(diffReportList) ? (
                                                            <HorizontalBar
                                                                height={
                                                                    diffReportList.length * 30 >= 200
                                                                        ? diffReportList.length * 30
                                                                        : 200
                                                                }
                                                                data={engChart.diffReport.data}
                                                                options={engChart.diffReport.options}
                                                            />
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </div>
                                                    <div className="table type2">
                                                        <table>
                                                            <colgroup>
                                                                <col key={`eng_diff_col_${0}`} width="20%" />
                                                                {diffReportList &&
                                                                    diffReportList?.map((_, index) => {
                                                                        return (
                                                                            <col
                                                                                key={`eng_diff_col_${index + 1}`}
                                                                                width={`${80 / 3}%`}
                                                                            />
                                                                        );
                                                                    })}
                                                            </colgroup>
                                                            <thead>
                                                                <tr>
                                                                    <th>단원명</th>
                                                                    <th>Lev. 1</th>
                                                                    <th>Lev. 2</th>
                                                                    <th>Lev. 3</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {!_.isEmpty(diffReportList) ? (
                                                                    diffReportList?.map(
                                                                        ({ UNIT_NAME, LV_1, LV_2, LV_3 }, index) => {
                                                                            return (
                                                                                <tr key={`eng_diff_tr_${index}`}>
                                                                                    <td>{UNIT_NAME}</td>
                                                                                    <td>{LV_1}</td>
                                                                                    <td>{LV_2}</td>
                                                                                    <td>{LV_3}</td>
                                                                                </tr>
                                                                            );
                                                                        },
                                                                    )
                                                                ) : (
                                                                    <tr>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                        <td></td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    {/* textarea에 선 없애야 할 경우 <div className="comment-box no-border">로 수정 */}
                                                    {TCHR_OPIN ? (
                                                        <div className="comment-box">
                                                            <h3>선생님 의견</h3>
                                                            <textarea
                                                                cols="30"
                                                                rows="10"
                                                                style={{ padding: 12, lineHeight: 1.5 }}
                                                                value={TCHR_OPIN}
                                                                readOnly
                                                            />
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {/* wrapper end */}
            </div>
            {/* wrap end  */}
        </div>
    );
}
